<template>
  <file-container
    :files="files"
    :allow-to-submit="isSubmittedStatus"
    @on-download-file="onDownloadFileHandler"
    @on-amend-file="onAmendFileHandler($event)"
  />
</template>

<script>
import edenStatus from '@/utils/constants/edenStatus.js';
import DocumentServices from '@/modules/report/document';
import Service from '@/services/api/edendisputeResolution.api';
import FileContainer from '@/views/eden/shared/components/file/FileContainer.vue';

export default {
  name: 'FilesTab',
  components: {
    FileContainer,
  },
  props: {
    edenDisputeResolutionId: {
      type: [String, Number],
      default: null,
    },
    status: {
      type: [String, Number],
      default: null,
    },
  },
  data: () => ({
    files: [],
  }),
  computed: {
    isSubmittedStatus() {
      return this.status === edenStatus.SUBMITTED;
    },
  },
  async mounted() {
    await this.fetchFiles();
  },
  methods: {
    async fetchFiles() {
      const response = await Service.getFiles(this.edenDisputeResolutionId);
      this.files = response.data;
    },
    async onDownloadFileHandler(fileId) {
      const { data } = await Service.getFile(fileId);
      DocumentServices.Download(data);
    },
    onAmendFileHandler() {
      // Handle file amendment logic here
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/variables/_colors.scss';
</style>
